import React from 'react'
import Sidebar from '../../Components/sideBar'

function AllowanceAndDeductions() {
  return (
    <h1>
      Allowance and Deductions
    </h1>
  )
}

export default AllowanceAndDeductions
